import { render, staticRenderFns } from "./RipaFormSubheader.vue?vue&type=template&id=dd50bdf6"
import script from "./RipaFormSubheader.vue?vue&type=script&lang=js"
export * from "./RipaFormSubheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports